module.exports = __webpack_public_path__ + "img/125.c144212a.png";